<template>
    <input
      required
      :type="inputType"
      class="form-control"
      :placeholder="placeholder"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      
      @keypress.enter="sendPassword($event)"
    >
    <!-- @blur="$emit('validateInput', modelValue)" -->
      <div class="eye-container">
      <i
        :class="eyeClass"
        aria-hidden="true"
        @click="toggleShowPassword"
      ></i>
    </div>
    <slot name="message"></slot>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "",
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  emits: ['validateInput', 'update:modelValue'],
  data() {
    return {
      showPassword: false
    };
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },

    sendPassword(e) {
      this.$emit('update:modelValue', e.target.value);
      this.$emit('validateInput', e.target.value);
    }

  },
  computed: {
      inputType() {
          return this.showPassword ? 'text' : 'password';
      },
      eyeClass() {
          return this.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye';
      }
  },
};
</script>

<style scoped>
.form-group.invalid input,
.form-group.invalid label {
  border-color: #cb1818;
}

.form-group.invalid label,
.form-group.invalid .invalid-text {
  color: #cb1818;
}

.eye-container i {
  cursor: pointer;
  position: absolute;
  top: 12px;
  left: calc(100% - 26px);
}

.form-group.has-icon label+input+.eye-container i {
  top: 37px;
}
</style>